<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import OcupationalNewMedicineAPI from "@/services/standards/ocupationalMedicine/ocupationalNewMedicineAPI";
import MedicinaOcupacional from "@/components/standard/OcupationalMedicine/medicina-ocupacional";

/**
 * Form elements component
 */
export default {
  page: {
    title: "3.1.1 Evaluaciones médicas ocupacionales",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    MedicinaOcupacional,
  },
  data() {
    
    return {
      title: "3.1.1 Evaluaciones médicas ocupacionales",
       items: [
       
        {
          text: "Estandares",
          href: "/forms/estandares ",
        },
        {
          text: "Medicina Ocupacional",
          active: true,
        },
      ],
      contenido: null,
      companies_id: null,
    };
  }, 
  methods: {
         
   getRedirectNewMedicineCompany() {
      OcupationalNewMedicineAPI.getRedirectNewMedicineCompany({
        companies_id: this.$route.params.id,
        items_id: 2
      })
        .then((response) => {
          this.contenido = response;
        })
        .catch(error => {
          console.log(error)
        })
    },

     
  },

  mounted() {
  this.getRedirectNewMedicineCompany()
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>

    <div class="row animated animatedFadeInUp fadeInUp">
    
      <MedicinaOcupacional
      /> 

      
    </div>
  </Layout>
</template>

